import styles from '../pa_checklist.module.scss';
import MaterialIcon from 'material-icons-react';

const ImageCompAnalise = ({ 
  item, 
  index, 
  onFileChange, 
  onRemove, 
  type = 'default',
  combinationValues = [],
  onRemovePermanent,
  localizacao,
  defeito
}) => {
  const inputId = `imageInput-${type}-${index}`;
  
  return (
    <div className={styles.images_arr} style={{ width: '33%' }}>
      <div className={styles.image_container}>
        <img
          src={item.imagem ? URL.createObjectURL(item.imagem) : 'img/camera_icon.png'}
          alt={`preview_${index}`}
          width={item.imagem ? 100 : 40}
          height={item.imagem ? 100 : 40}
          style={{ opacity: item.imagem ? '1' : '0.4' }}
        />
        <label
          htmlFor={inputId}
          className={styles.input_label}
        />
        <input
          type="file"
          accept="image/*"
          id={inputId}
          style={{ display: "none" }}
          onChange={(e) => onFileChange(e, index)}
        />
        {item.imagem && (
          <div className={styles.remove_btn} onClick={() => onRemove(index)}>
            <MaterialIcon
              icon={'remove_circle'}
              size={16}
              color='#FFFFFF'
            />
          </div>
        )}
        {type === 'optional' && (
          <div 
            className={styles.remove_permanent_btn} 
            onClick={() => onRemovePermanent(index)}
            title="Remover permanentemente"
          >
            <MaterialIcon
              icon={'delete_forever'}
              size={16}
              color='#FFFFFF'
            />
          </div>
        )}
      </div>

      {type === 'default' && combinationValues.map((value, combIndex) => (
        <div
          key={`imagem_label_${index}_${combIndex}`}
          className={styles.sub_form_label}
          style={{ 
            margin: combIndex === 0 ? '4px 0px 0px' : '0px', 
            fontSize: '12px', 
            width: '100%', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap', 
            textAlign: 'center', 
            padding: '0px 10px' 
          }}
        >
          {value}
        </div>
      ))}

      {type === 'prova-roupa' && (
        <>
          <span style={{
            fontSize: '12px',
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            padding: '0px 10px'
          }}>
            {localizacao}
          </span>
          <span style={{
            fontSize: '12px',
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            padding: '0px 10px'
          }}>
            {defeito}
          </span>
        </>
      )}
    </div>
  );
}

export default ImageCompAnalise;
